// import defaultSettings from '@/settings'

const title = "Ladies In Tech";

export default function getPageTitle(pageTitle) {
  if (pageTitle) {
    return `${pageTitle} - ${title}`;
  }
  return `${title}`;
}
